import { authClient } from '@/customer/lib/auth'

/** Whether the current portal session was minted by staff impersonation, plus whether that is still being resolved. */
export function useIsImpersonated(): { isPending: boolean; isImpersonated: boolean } {
  const { data, isPending } = authClient.useSession()
  return { isPending, isImpersonated: Boolean(data?.session.impersonatedBy) }
}
